import { SerpContent } from '../../../domain/graphcms';

export function hasSerpContent(serpData: { serpContents: SerpContent[] | null } | null) {
  return !!(serpData && serpData.serpContents && serpData.serpContents[0]);
}
